// components/widgets/Identity/FutureYou/Steps/LocationStep.jsx
import React from "react";

const LocationStep = ({ value, onChange, onEnterNext }) => {
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && value?.trim()) {
      e.preventDefault();
      onEnterNext?.();
    }
  };

  return (
    <div>
      <p className="font-bold font-gotham text-sm md:text-[18px] text-[#323232] mb-2">
        Where would you ideally like to be based?
      </p>
      <p className="text-sm md:text-[15px] text-[#888888] font-gotham font-normal mb-6 md:mb-8">
        Eg. Bangalore, New York, London, or fully remote
      </p>

      <input
        type="text"
        placeholder="Type here..."
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={handleKeyDown}   // ✅ Enter → next
        className={`w-full border-b-2 font-gotham font-medium text-lg md:text-xl 2xl:text-2xl ${
          value ? "border-[#54B0AF]" : "border-[#E3E3E3]"
        } focus:border-[#54B0AF] outline-none py-3 ${
          value ? "text-[#54B0AF]" : "text-gray-900"
        } placeholder-gray-400 transition-colors font-medium`}
      />
    </div>
  );
};

export default LocationStep;